<!-- Loading Image -->
<p *ngIf="showLoadingImage" class="centeredImage">
    <img alt="Loading in progress. Please wait." src="./assets/images/tyler%20sis%20loading.gif" />
</p>

<!-- App content -->
<div *ngIf="!showLoadingImage" style="height: 100%; width:100%; display: flex; flex-direction: column; overflow: hidden;"
    #appElement>
    <div class="sidenav-container">
        <mat-sidenav-container class="mat-sidenav-container" [style.marginTop.px]="0">
            <mat-sidenav #snav [mode]="'over'" [fixedInViewport]="true" fixedTopGap="0" class="print-ignore"
                (openedStart)="sideNaveOpened()">
                <mat-nav-list>
                    <application-menu (navigated)="closeSideNav()"></application-menu>
                </mat-nav-list>
            </mat-sidenav>
            <mat-sidenav-content>
                <app-header (toggleEvent)="snav.toggle()" #appHeader
                    class="sis-app-header material-dark-theme print-ignore" [hidden]="!showAppHeader"></app-header>
                <div id="print-content" style="display: flex; flex-direction: row; flex-grow: 1; overflow: hidden;"
                    class="print-content">

                    <!-- Page Content -->
                    <div class="sis-app-root">
                        <router-outlet (activate)="
                            setCurrentComponent($event)">
                        </router-outlet>
                    </div>

                    <!-- Filter Panel -->
                    <div *ngIf="showFilter">
                        <ng-container [ngTemplateOutlet]="filterTemplate"></ng-container>
                    </div>
                </div>
            </mat-sidenav-content>
        </mat-sidenav-container>
    </div>

</div>

<!-- This needs to be a sibling of the root -->
<spinner aria-live="polite" aria-atomic="true"></spinner>